import { FormFieldProps } from './index';
import {
    Button,
    FormControl,
    FormHelperText,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { useFormErrors } from '../../../contexts/FormContext';

export default function DefaultFormField({
    type,
    name,
    label,
    required,
    disabled,
    value,
    onChange,
    cssClassName,
    onKeyUp,
    inputVars,
    help,
}: FormFieldProps) {
    const { translate } = useTranslation();

    const { error } = useFormErrors(name);

    const renderClickVar = (clickVar: string, varIndex: number) => {
        const select = () => {
            const sel = window.getSelection();
            if (sel && sel.rangeCount > 0) {
                onChange(value?.replace(sel.toString(), clickVar));
            } else {
                onChange(value + clickVar);
            }
        };

        return (
            <Button
                key={`btn-var-${varIndex}`}
                onClick={select}
                variant="text"
                sx={{ p: 0 }}>
                <Typography>{clickVar}</Typography>
            </Button>
        );
    };

    return (
        <FormControl fullWidth className={cssClassName}>
            <Stack spacing={0.5}>
                <TextField
                    name={name}
                    label={translate(label)}
                    InputLabelProps={{
                        sx: { lineHeight: 1, color: 'text.secondary', mt: 0.5 },
                    }}
                    value={typeof value !== 'undefined' ? value : ''}
                    variant="outlined"
                    onChange={event => onChange(event.target.value)}
                    onKeyUp={onKeyUp}
                    error={Boolean(error)}
                    required={required}
                    type={type === 'money' ? 'number' : type}
                    autoComplete={name}
                    disabled={disabled}
                    inputProps={{
                        step: type === 'money' ? 0.01 : undefined,
                        min: type === 'money' ? 0 : undefined,
                    }}
                />
                {Boolean(inputVars) && (
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {Object.values(inputVars ?? {}).map(renderClickVar)}
                    </Stack>
                )}
                {help && (
                    <FormHelperText id={`${name}-help`}>
                        {translate(help)}
                    </FormHelperText>
                )}
                {Boolean(error && typeof error === 'string') && (
                    <FormHelperText error id={`${name}-error`}>
                        {translate(error ?? 'error')}
                    </FormHelperText>
                )}
            </Stack>
        </FormControl>
    );
}
